import React, { forwardRef } from 'react'
import { Icon, iconDefaultProps, IconProps } from '../Icon'

type AlarmClockMinusIconProps = IconProps

const AlarmClockMinusIcon = forwardRef<SVGSVGElement, AlarmClockMinusIconProps>(
  (props: AlarmClockMinusIconProps, ref) => (
    <Icon {...props} ref={ref}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M5 3 2 6m20 0-3-3M6 19l-2 2m14-2 2 2M9 13h6m-3 8a8 8 0 1 0 0-16.001A8 8 0 0 0 12 21Z"
        fill="none"
      ></path>
    </Icon>
  ),
)

AlarmClockMinusIcon.displayName = 'AlarmClockMinusIcon'
AlarmClockMinusIcon.defaultProps = iconDefaultProps

export type { AlarmClockMinusIconProps }
export { AlarmClockMinusIcon }
